import { useEffect } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import { Box } from '@mui/material';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  selectFilterTimeStart,
  selectFilterTimeEnd,
  selectFlightTimes,
} from '../../redux/flightData/flightData.selector';

import {
  setFilterTimeStart,
  setFilterTimeEnd,
  setFilteredFlightIds,
} from '../../redux/flightData/flightData.actions';

import moment from 'moment';

import './time-range-picker.scss';

const TimeRangePicker = ({
  setStart,
  setEnd,
  start,
  end,
  flightTimes,
  setFlights,
}) => {
  const handleChange = (options, name) => {
    if (options !== null && options !== undefined) {
      if (name === 'start') {
        setStart(options);
      } else {
        setEnd(options);
      }
      console.log(options.format('hh:mm a'));
    }
  };

  useEffect(() => {
    let filteredFlights = [];
    Object.keys(flightTimes).forEach((flight, i) => {
      if (flight && flightTimes[flight]) {
        let dep = flightTimes[flight].schedDep;
        if (moment(dep, ['hh:mm A']).isBetween(start, end)) {
          filteredFlights.push(flight);
        }
      }
      if (Object.keys(flightTimes).length - 1 === i) {
        setFlights(filteredFlights);
      }
    });
  }, [end, flightTimes, setFlights, start]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        backgroundColor: '#F8F9F3',
        padding: '10px',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginY: '10px',
        height: '80px',
      }}
    >
      <p style={{ textAlign: 'center' }}>Time Filtering</p>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <TimePicker
          minutesStep={5}
          className="start-time-picker"
          onChange={(options) => handleChange(options, 'start')}
          label={'Start'}
          ampm
          value={start}
          renderInput={(params) => <TextField {...params} />}
        />
        <span className="time-picker-divider">to</span>
        <TimePicker
          ampm
          minutesStep={5}
          label={'End'}
          clearable
          className="end-time-picker"
          onChange={(options) => handleChange(options, 'end')}
          value={end}
          minTime={start}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </Box>
  );
};

const mapStateToProps = createStructuredSelector({
  start: selectFilterTimeStart,
  end: selectFilterTimeEnd,
  flightTimes: selectFlightTimes,
});

const mapDispatchToProps = (dispatch) => ({
  setStart: (start) => dispatch(setFilterTimeStart(start)),
  setEnd: (end) => dispatch(setFilterTimeEnd(end)),
  setFlights: (flightIds) => dispatch(setFilteredFlightIds(flightIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeRangePicker);

// console.log(moment("12:15 PM", ["h:mm A"]).isBetween(moment("11:00 AM", ["hh:mm A"]), moment("11:00 PM", ["hh:mm A"]), "minutes"));
